import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { loginAsync } from '../store/authSlice';
import BrandLogo from '../mobile/BrandLogo';
export default function LoginPage() {
  const dispatch = useDispatch();
  const { isAuthenticated, loading, error } = useSelector(state => state.auth);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  if (isAuthenticated) return <Navigate to="/" replace />;
  return <div className="mobile-auth"><div className="auth-content"><div className="wordmark"><BrandLogo /></div><h1>Il tuo spazio.<br />Sempre con te.</h1><p>Chat, agenda e piccoli automatismi.<br />Accedi e riprendi da dove eri rimasto.</p>
    <form className="auth-form" onSubmit={e => { e.preventDefault(); dispatch(loginAsync({ email, password })); }}>
      {error && <p className="auth-error" role="alert">{typeof error === 'string' ? error : 'Accesso non riuscito. Riprova.'}</p>}
      <div><label htmlFor="email">Email</label><input id="email" type="email" autoComplete="username" inputMode="email" autoCapitalize="none" required value={email} onChange={e => setEmail(e.target.value)} placeholder="La tua email" /></div>
      <div><label htmlFor="password">Password</label><input id="password" type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} placeholder="La tua password" /></div>
      <button disabled={loading} type="submit">{loading ? 'Accesso in corso…' : 'Accedi a Wozzap'}</button>
    </form><div className="auth-footer">Per entrare serve un invito. Password dimenticata? Chiedi un nuovo link a chi ti ha invitato.</div>
    <div className="auth-footer"><a href="/?preview=1">Esplora l’anteprima con dati di esempio</a></div>
  </div></div>;
}

